import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { trackCheckoutSessionStarted } from '../utils/analytics';
import { buildStripeUrl } from '../utils/environment';

/**
 * Navigation component for all pages except homepage
 * Props:
 * - showDemoButton: boolean (default: true) - whether to show "Watch Demo" button
 * - primaryButtonText: string (default: "Buy Today, Own Forever") - text for primary CTA button
 * - secondaryButtonText: string (default: "Watch Demo") - text for secondary button
 * - onSecondaryClick: function - custom handler for secondary button (defaults to navigating to /demo)
 * - trackingLocation: string - location identifier for analytics tracking
 */
export default function Navigation({ 
  showDemoButton = true,
  primaryButtonText = "Buy Today, Own Forever",
  secondaryButtonText = "Watch Demo",
  onSecondaryClick = null,
  trackingLocation = 'page'
}) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handlePurchaseClick = () => {
    trackCheckoutSessionStarted(trackingLocation);
    const stripeUrl = buildStripeUrl();
    if (stripeUrl) {
      window.open(stripeUrl, '_blank');
    } else {
      console.error('Failed to build Stripe URL. Check environment configuration.');
    }
    setIsMenuOpen(false);
  };

  const handleSecondaryClick = () => {
    if (onSecondaryClick) {
      onSecondaryClick();
    } else {
      navigate('/demo');
    }
    setIsMenuOpen(false);
  };

  const handleBrandClick = () => {
    navigate('/');
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="walkthrough-nav">
      <div className="walkthrough-nav-container">
        <div className="walkthrough-nav-brand" onClick={handleBrandClick}>
          <img src="/logo192.png" alt="Solidly Finance Logo" className="brand-logo" />
          <span className="brand-name">Solidly Finance</span>
        </div>

        {/* Hamburger Menu Button */}
        <button 
          className={`nav-hamburger ${isMenuOpen ? 'open' : ''}`}
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Navigation Actions */}
        <div className={`walkthrough-nav-actions ${isMenuOpen ? 'open' : ''}`}>
          {showDemoButton && (
            <button 
              className="btn btn-secondary"
              onClick={handleSecondaryClick}
            >
              {secondaryButtonText}
            </button>
          )}
          <button 
            className="btn btn-primary"
            onClick={handlePurchaseClick}
          >
            {primaryButtonText}
          </button>
        </div>
      </div>
    </nav>
  );
}
